/*
 *
 * PaymentLinks constants
 *
 */
import { ALL, BATCH, ORDERS } from 'utils/constants';

export const BASE_ACTION_CONSTANT = 'app/PaymentLinks';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SET_ACTIVE_NAVIGATION = `${BASE_ACTION_CONSTANT}/SET_ACTIVE_NAVIGATION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const SEARCH_PAYMENT_LINKS = `${BASE_ACTION_CONSTANT}/SEARCH_PAYMENT_LINKS`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const SAVE_PAYMENT_LINKS = `${BASE_ACTION_CONSTANT}/SAVE_PAYMENT_LINKS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const CREATE_PAYMENT_LINK = `${BASE_ACTION_CONSTANT}/CREATE_PAYMENT_LINKS`;
export const CREATE_PAYMENT_LINK_SAVE_RESPONSE = `${BASE_ACTION_CONSTANT}/CREATE_PAYMENT_LINK_SAVE_RESPONSE`;

export const UPDATE_PAYMENT_LINK = `${BASE_ACTION_CONSTANT}/UPDATE_PAYMENT_LINKS`;
export const UPDATE_PAYMENT_LINK_SAVE_RESPONSE = `${BASE_ACTION_CONSTANT}/UPDATE_PAYMENT_LINK_SAVE_RESPONSE`;

export const BATCH_UPLOAD_SUBMIT = `${BASE_ACTION_CONSTANT}/BATCH_UPLOAD_SUBMIT`;
export const BATCH_UPLOAD_SAVE_RESPONSE = `${BASE_ACTION_CONSTANT}/BATCH_UPLOAD_SAVE_RESPONSE`;

export const RESET_BATCH_UPLOAD_RESPONSE = `${BASE_ACTION_CONSTANT}/RESET_BATCH_UPLOAD_RESPONSE`;
export const SEND_PAYMENT_LINK_REMINDER = `${BASE_ACTION_CONSTANT}/SEND_PAYMENT_LINK_REMINDER`;

export const BATCH_DOWNLOAD = `${BASE_ACTION_CONSTANT}/BATCH_DOWNLOAD`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const DOWNLOAD_ERROR_LOG = `${BASE_ACTION_CONSTANT}/DOWNLOAD_ERROR_LOG`;

export const BATCH_FORCE_UPLOAD = `${BASE_ACTION_CONSTANT}/BATCH_FORCE_UPLOAD`;

export const GET_WHITELISTING_DATA = `${BASE_ACTION_CONSTANT}/GET_WHITELISTING_DATA`;

export const ADD_CUSTOM_THANKYOU_MESSAGE = `${BASE_ACTION_CONSTANT}/ADD_CUSTOM_THANKYOU_MESSAGE`;

export const SAVE_CUSTOM_THANKYOU_MESSAGE = `${BASE_ACTION_CONSTANT}/SAVE_CUSTOM_THANKYOU_MESSAGE`;

export const GET_WHITELISTING_URL = '/pg/merchant-domain-app-info';

export const HEADINGS = {
  [ALL]: [
    {
      key: 'txTime',
      displayName: 'Created At',
      width: 0.15,
    },
    {
      key: 'createdBy',
      displayName: 'Created By',
      width: 0.15,
    },
    {
      key: 'refId',
      displayName: 'Link ID',
      width: 0.15,
    },
    {
      key: 'CFOrderId',
      displayName: 'CF Link ID',
      width: 0.15,
    },
    {
      key: 'orderAmount',
      displayName: 'Amount',
      width: 0.12,
      align: 'right',
    },
    {
      key: 'customerPhone',
      displayName: 'Phone No.',
      width: 0.12,
    },
    {
      key: 'customerEmail',
      displayName: 'Email ID',
      width: 0.18,
    },
    {
      key: 'txStatus',
      displayName: 'Status',
      width: 0.1,
    },
    {
      key: 'paymentLinkCTA',
      displayName: '',
      width: 0.09,
    },
  ],
  [BATCH]: [
    {
      key: 'txTime',
      displayName: 'Uploaded At',
      width: 0.15,
    },
    {
      key: 'batchId',
      displayName: 'Batch ID',
      width: 0.12,
    },
    {
      key: 'fileName',
      displayName: 'File Name',
      width: 0.18,
    },
    {
      key: 'linksCreated',
      displayName: 'Links Created',
      width: 0.12,
    },
    {
      key: 'rowCount',
      displayName: 'Records Uploaded',
      width: 0.12,
    },
    {
      key: 'status',
      displayName: 'Status',
      width: 0.1,
    },
    {
      key: 'paymentLinkCTA',
      displayName: '',
      width: 0.05,
    },
  ],
  [ORDERS]: [
    {
      key: 'txTime',
      displayName: 'Date & Time',
      width: 0.13,
    },
    {
      key: 'orderID',
      displayName: 'Order ID',
      width: 0.17,
    },
    {
      key: 'txnId',
      displayName: 'Transaction ID',
      width: 0.13,
    },
    {
      key: 'paymentRequestId',
      displayName: 'CF Link ID',
      width: 0.1,
    },
    {
      key: 'referenceId',
      displayName: 'Link ID',
      width: 0.13,
    },
    {
      key: 'orderAmount',
      displayName: 'Amount',
      width: 0.11,
      align: 'right',
    },
    {
      key: 'customerPhone',
      displayName: 'Phone No.',
      width: 0.12,
    },
    {
      key: 'customerEmail',
      displayName: 'Email ID',
      width: 0.14,
    },
    {
      key: 'txStatus',
      displayName: 'Status',
      width: 0.14,
    },
  ],
};

export const GET_MERCHANT_CONFIG = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_CONFIG`;
export const GET_MERCHANT_CONFIG_SAVE_RESPONSE = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_CONFIG_SAVE_RESPONSE`;

export const CANCEL_PAYMENT_LINK = `${BASE_ACTION_CONSTANT}/CANCEL_PAYMENT_LINK`;

export const SEARCH_PAYMENT_LINKS_ALL_URL = {
  url: '/pg/pggrowth/links',
  method: 'GET',
};

export const SEARCH_PAYMENT_LINKS_BATCH_URL = {
  url: '/pg/pggrowth/links-batch',
  method: 'GET',
};

export const SEARCH_PAYMENT_LINKS_ORDERS_URL = {
  url: '/pg/pggrowth/payments',
  method: 'GET',
};

export const ALL_CTA = 'CREATE_PAYMENT_LINK';
export const BATCH_CTA = BATCH;

export const CREATE_PAYMENT_LINKS_URL = {
  url: '/pg/pggrowth/links',
  method: 'POST',
};
export const UPDATE_PAYMENT_LINKS_URL = {
  url: '/pg/pggrowth/links/$shortUrl$',
  method: 'PATCH',
};

export const PAYMENT_LINK_REMINDER_URL = {
  url: '/pg/paymentLink/reminder',
  method: 'POST',
};

export const BATCH_UPLOAD_URL = {
  url: '/pg/pggrowth/links-batch/offer',
  method: 'POST',
};

export const UPDATE_PAYMENT_LINKS_FIELDS = [
  'expiry_time',
  'notes',
  'description',
  'thank_you_msg',
  'terms_and_conditions',
  'enable_invoice',
  'linkType',
  'amount',
  'customer',
  'min_amount',
  'currency',
  'send_reminder',
  'return_url',
];

export const BATCH_DOWNLOAD_URL = {
  url: '/pg/pggrowth/links-batch/$batchID$/report',
  method: 'POST',
};

export const CANCEL_PAYMENT_LINK_URL = {
  url: '/pg/pggrowth/links/$shortUrl$',
  method: 'DELETE',
};

export const DOWNLOAD_ERROR_LOG_URL = {
  url: '/pg/pggrowth/links-batch/validation-report',
  method: 'POST',
};

export const BATCH_FORCE_UPLOAD_URL = {
  url: '/pg/pggrowth/links-batch/force',
  method: 'POST',
};

export const ADD_CUSTOM_THANKYOU_MESSAGE_URL = {
  url: '/pg/pggrowth/customMessage',
  method: 'POST',
};

export const ALL_URL =
  'https://www.cashfree.com/docs/payments/no-code/payment-link#payment-link';

export const BATCH_URL =
  'https://www.cashfree.com/docs/payments/no-code/payment-link#create-via-batch-upload';

export const ORDERS_URL =
  'https://www.cashfree.com/docs/help/payment-links/faqs/faqs';

export const BATCH_STATUS = {
  SUCCESS: 'PROCESSED',
  PARTIAL: 'PROCESSED',
  FAILED: 'FAILED',
};

export const REVERSE_BATCH_STATUS_MAPPING = {
  PROCESSED: ['SUCCESS', 'PARTIAL'],
  PROCESSING: ['QUEUED', 'PROCESSING'],
  FAILED: ['FAILED'],
};

export const MENU_ITEMS = [
  {
    key: 'SEND',
    text: 'Send Reminder',
    value: 'REMINDER',
  },
  {
    key: 'COPY_TO_CLIPBOARD',
    text: 'Copy Link',
    value: 'COPY_LINK',
  },
  {
    key: 'EDIT',
    text: 'Edit',
    value: 'EDIT_PAYMENT_LINK',
  },
  {
    key: 'CANCEL',
    text: 'Cancel',
    value: 'CANCEL',
  },
];

export const DEFAULT_PLACEHOLDER_TEXT = '--';
